export const REMIL_FIGURLER = [
  {
    id: "yol",
    no: 1,
    isim: "Yol",
    gelenekselAd: "Via",
    pattern: ["tek", "tek", "tek", "tek"],
    sembol: "●\n●\n●\n●",
    anaTemalar: ["Hareket", "Yolculuk", "Başlangıç", "Açılım"],
    genelAnlam: "Yeni bir yolculuğun başladığını, değişimin kapıda olduğunu gösterir. Durağanlıktan çıkış zamanı.",
    askAnlam: "İlişkide yeni bir sayfa açılıyor. Bekleyenler için bir hareket, başlayanlar için ilerleme sinyali.",
    isAnlam: "Kariyer veya iş hayatında yeni bir fırsat kapısı aralıklanıyor. Adım atmaktan çekinme.",
    paraAnlam: "Maddi konularda bir hareket bekleniyor. Beklenmedik bir gelir veya yeni bir kaynak kapısı.",
    gelecekAnlam: "Yakın dönemde önemli bir değişim veya yeni başlangıç sinyalleri güçlü.",
    tavsiye: "Harekete geç. Bekleme süresi doldu, sıra adım atmada.",
    uyari: "Çok fazla seçenek arasında kaybolma. Bir yol seç ve ilerle.",
  },
  {
    id: "kazanc",
    no: 2,
    isim: "Kazanç",
    gelenekselAd: "Acquisitio",
    pattern: ["cift", "cift", "tek", "cift"],
    sembol: "●●\n●●\n●\n●●",
    anaTemalar: ["Kazanım", "İlerleme", "Maddi artış", "Başarı"],
    genelAnlam: "Elde etme, kazanç ve sonuç alma zamanı. Emekler karşılığını buluyor.",
    askAnlam: "İlişkide olumlu gelişmeler, karşılıklı kazanım dönemi. Bekleyenler için güzel haberler.",
    isAnlam: "İş hayatında somut başarılar ve maddi kazanımlar kapıda.",
    paraAnlam: "Finansal açıdan olumlu bir dönem. Yatırımlar meyvesini veriyor.",
    gelecekAnlam: "Yakın dönem kazanımlarla dolu. Sabır gösterenlere güzel sürprizler bekleniyor.",
    tavsiye: "Fırsatları değerlendir. Kazanım döneminde cömert ve paylaşımcı ol.",
    uyari: "Kazancı korumak da kazanmak kadar önemli. Savurganlıktan kaçın.",
  },
  {
    id: "bulusma",
    no: 3,
    isim: "Buluşma",
    gelenekselAd: "Amissio",
    pattern: ["tek", "cift", "cift", "tek"],
    sembol: "●\n●●\n●●\n●",
    anaTemalar: ["Keşif", "Arayış", "Kayıp/Bulma", "Yeniden"],
    genelAnlam: "Bir şeyin gitmesi, başka bir şeyin gelmesi için yer açar. Kayıp gibi görünen şey aslında bir dönüşümdür.",
    askAnlam: "İlişkide duygusal bir ayrılık veya mesafe söz konusu olabilir, ancak bu yeni bir buluşmaya zemin hazırlıyor.",
    isAnlam: "İş değişikliği veya proje kaybı ilk başta zor görünse de daha iyi fırsatlara kapı aralıyor.",
    paraAnlam: "Maddi bir kayıp yaşanabilir, ancak bu geçici. Daha büyük bir kazanç için alan açılıyor.",
    gelecekAnlam: "Bırakma ve yeniden başlama enerjisi yoğun. Geçmişte ısrar etme.",
    tavsiye: "Bırakmayı öğren. Giden şey seni daha iyisine hazırlıyor.",
    uyari: "Kayıp korkusuyla fırsatları kaçırma. Değişime direnme.",
  },
  {
    id: "mutluluk",
    no: 4,
    isim: "Mutluluk",
    gelenekselAd: "Albus",
    pattern: ["cift", "tek", "cift", "cift"],
    sembol: "●●\n●\n●●\n●●",
    anaTemalar: ["Huzur", "İstikrar", "Rahatlık", "Bereket"],
    genelAnlam: "Açıklık, bereket ve huzur dönemi. Zihin duruldu, kalp hafifliyor.",
    askAnlam: "İlişkide sükûnet ve anlayış hâkim. Huzurlu ve dengeli bir dönem.",
    isAnlam: "İş hayatında istikrar ve netlik. Doğru kararlar almak için uygun zaman.",
    paraAnlam: "Maddi konularda bir rahatlama ve denge. Bereket kapısı aralanıyor.",
    gelecekAnlam: "Sakin ama güçlü bir dönem geliyor. Temeller atılıyor.",
    tavsiye: "Bu huzurlu dönemi içini doldurmak için kullan. Büyü sessizlikte saklı.",
    uyari: "Konfor alanına çok fazla yerleşme. Büyümeyi unutma.",
  },
  {
    id: "haber",
    no: 5,
    isim: "Haber",
    gelenekselAd: "Populus",
    pattern: ["cift", "cift", "cift", "cift"],
    sembol: "●●\n●●\n●●\n●●",
    anaTemalar: ["İletişim", "Ortaklık", "Destek", "Topluluk"],
    genelAnlam: "Çevre ve iletişim ön plana çıkıyor. Haberler, insanlar, bağlantılar önem kazanıyor.",
    askAnlam: "İlişkide iletişim kritik. Söylenmeyenler birikmesin, konuş.",
    isAnlam: "Ortaklıklar ve ekip çalışması ön plana çıkıyor. Ağ genişliyor.",
    paraAnlam: "Çevreden gelecek fırsatlar ve destekler maddi dengeyi güçlendiriyor.",
    gelecekAnlam: "Topluluk ve bağlantılar üzerinden gelişmeler yaşanacak.",
    tavsiye: "Doğru insanlarla doğru iletişimi kur. Çevren senin gücün.",
    uyari: "Kalabalıkta kaybolma. Herkesin sesi değil, doğru sesin peşinden git.",
  },
  {
    id: "bilinc",
    no: 6,
    isim: "Bilinç",
    gelenekselAd: "Puella",
    pattern: ["tek", "cift", "tek", "cift"],
    sembol: "●\n●●\n●\n●●",
    anaTemalar: ["Sezgi", "Öğrenme", "Plan", "Hazırlık"],
    genelAnlam: "İçgörü ve sezginin güçlendiği bir dönem. Öğrenme ve hazırlık zamanı.",
    askAnlam: "İlişkide duygusal zekâ ve empati belirleyici. Karşındakini anlamaya çalış.",
    isAnlam: "Yeni beceriler edinme ve stratejik düşünme zamanı. Plan yap.",
    paraAnlam: "Bilinçli harcama ve planlama maddi dengeyi güçlendirir.",
    gelecekAnlam: "Hazırlık yapanlar için parlak bir dönem geliyor.",
    tavsiye: "Sezgilerine güven. İçindeki ses seni doğruya götürüyor.",
    uyari: "Aşırı analiz felce yol açabilir. Bir noktada karar verip ilerlemelisin.",
  },
  {
    id: "engel",
    no: 7,
    isim: "Engel",
    gelenekselAd: "Rubeus",
    pattern: ["cift", "tek", "cift", "tek"],
    sembol: "●●\n●\n●●\n●",
    anaTemalar: ["Mücadele", "Zorluk", "Gecikme", "Dayanıklılık"],
    genelAnlam: "Engellerle yüzleşme zamanı. Bu zorluklar seni güçlendirmek için geliyor.",
    askAnlam: "İlişkide sürtüşme veya gerilim söz konusu. Sabır ve anlayış gerekiyor.",
    isAnlam: "İş hayatında gecikmeler veya engeller çıkabilir. Pes etme, strateji değiştir.",
    paraAnlam: "Maddi zorluklar geçici. Dikkatli ve sabırlı ol.",
    gelecekAnlam: "Zorluklar aşıldıkça güçlenme dönemi başlıyor.",
    tavsiye: "Engeli aşmak için önce onu kabul et. Direniş değil, akış.",
    uyari: "Öfke ve sabırsızlık durumu daha da karmaşık hale getirebilir.",
  },
  {
    id: "denge",
    no: 8,
    isim: "Denge",
    gelenekselAd: "Conjunctio",
    pattern: ["tek", "cift", "cift", "tek"],
    sembol: "●\n●●\n●●\n●",
    anaTemalar: ["Uyum", "Anlaşma", "Birlik", "Ortaklık"],
    genelAnlam: "Birleşme ve uyum enerjisi güçlü. Ortaklıklar ve anlaşmalar için uygun zaman.",
    askAnlam: "İlişkide derin bir uyum ve birliktelik dönemi. Bağlar güçleniyor.",
    isAnlam: "Ortaklıklar ve işbirlikleri için mükemmel zaman. Anlaşmalar hayırlı.",
    paraAnlam: "Ortak projeler veya ortaklıklar finansal kazanım getiriyor.",
    gelecekAnlam: "Birlikte daha güçlü. İşbirliği ön plana çıkıyor.",
    tavsiye: "Doğru insanlarla güç birliği yap. Tek başına değil, birlikte.",
    uyari: "Her ortaklık sana uygun değil. Seçici ol.",
  },
  {
    id: "guc",
    no: 9,
    isim: "Güç",
    gelenekselAd: "Carcer",
    pattern: ["tek", "tek", "cift", "tek"],
    sembol: "●\n●\n●●\n●",
    anaTemalar: ["Sınav", "Sorumluluk", "Kısıtlama", "Kendini koruma"],
    genelAnlam: "Sınırları test eden bir dönem. Bu kısıtlamalar seni daha güçlü yapıyor.",
    askAnlam: "İlişkide bazı sınırlar veya kısıtlamalar hissediliyor. Sabır gerekiyor.",
    isAnlam: "İş hayatında sorumluluklar artıyor. Bu bir sınav, geçeceksin.",
    paraAnlam: "Maddi konularda kısıtlamalar geçici. Disiplin ve tasarruf önemli.",
    gelecekAnlam: "Bu dönemin sınavları seni daha güçlü yapacak.",
    tavsiye: "Sınırlarını kabul et ama onlara esir olma. Güç içinde saklı.",
    uyari: "Kendini çok fazla kısıtlama. Nefes almak da gerekli.",
  },
  {
    id: "sans",
    no: 10,
    isim: "Şans",
    gelenekselAd: "Fortuna Major",
    pattern: ["cift", "tek", "tek", "cift"],
    sembol: "●●\n●\n●\n●●",
    anaTemalar: ["Aşk", "Fırsat", "Büyük kazanç", "Dönüm noktası"],
    genelAnlam: "Büyük şans ve güçlü fırsatlar kapıda. Bu dönem hayatında iz bırakacak.",
    askAnlam: "Aşk ve ilişkide büyük bir dönüm noktası yaklaşıyor. Hazır ol.",
    isAnlam: "Kariyer veya iş hayatında büyük bir fırsat penceresi açılıyor.",
    paraAnlam: "Büyük kazanç potansiyeli yüksek. Fırsatları kaçırma.",
    gelecekAnlam: "Hayatında iz bırakacak bir dönem geliyor. Gözlerini aç.",
    tavsiye: "Büyük fırsatlara hazırlıklı ol. Şans cesurları sever.",
    uyari: "Şansı zorlama. Doğal akan şeylere güven.",
  },
  {
    id: "toprak",
    no: 11,
    isim: "Toprak",
    gelenekselAd: "Terra",
    pattern: ["tek", "cift", "tek", "tek"],
    sembol: "●\n●●\n●\n●",
    anaTemalar: ["Aile", "Ev/Mülk", "Güven", "Köklenme"],
    genelAnlam: "Köklere dönüş ve güvenli liman. Aile, ev ve kalıcılık ön plana çıkıyor.",
    askAnlam: "İlişkide güven ve istikrar arayışı. Kalıcı bir bağ kurma isteği güçlü.",
    isAnlam: "İş hayatında sağlam temeller atmak ve güvenli adımlar önemli.",
    paraAnlam: "Gayrimenkul veya uzun vadeli yatırımlar için uygun dönem.",
    gelecekAnlam: "Kalıcı ve güvenli bir yapı kurma dönemi geliyor.",
    tavsiye: "Köklerine bağlı kal ama büyümeyi unutma. Güçlü kökler, uzun dallar.",
    uyari: "Güvenli alanda çok fazla kalma. Büyümek biraz risk gerektirir.",
  },
  {
    id: "isik",
    no: 12,
    isim: "Işık",
    gelenekselAd: "Tristitia",
    pattern: ["cift", "cift", "tek", "tek"],
    sembol: "●●\n●●\n●\n●",
    anaTemalar: ["Duygusal arınma", "Tamamlanma", "Bırakma", "Yeni sayfa"],
    genelAnlam: "Bir dönemin kapanması ve yeniden doğuş. Arınma ve tamamlanma zamanı.",
    askAnlam: "İlişkide eski yaraların iyileşme ve yeni bir başlangıç dönemi.",
    isAnlam: "İş hayatında bir dönem kapanıyor, yeni bir sayfa açılıyor.",
    paraAnlam: "Eski finansal yüklerin hafiflemesi ve yeni bir denge kurulması.",
    gelecekAnlam: "Arınmanın ardından aydınlık bir dönem geliyor.",
    tavsiye: "Geçmişi bırak. Işık, bırakmanın ardından geliyor.",
    uyari: "Melankoli ve geçmişe takılı kalmak ilerlemeyi engelliyor.",
  },
  {
    id: "zeka",
    no: 13,
    isim: "Zekâ",
    gelenekselAd: "Laetitia",
    pattern: ["tek", "tek", "tek", "cift"],
    sembol: "●\n●\n●\n●●",
    anaTemalar: ["Neşe", "Yaratıcılık", "Başarı", "Rahatlama"],
    genelAnlam: "Neşe ve yaratıcılığın dorukta olduğu bir dönem. Başarı ve ferahlama geliyor.",
    askAnlam: "İlişkide neşe ve hafiflik hâkim. Eğlenceli ve spontane bir dönem.",
    isAnlam: "Yaratıcılık ve zekânın parlayacağı bir dönem. Fikirler değer kazanıyor.",
    paraAnlam: "Yaratıcı çözümler maddi sorunların önünü açıyor.",
    gelecekAnlam: "Ferahlama ve başarı dolu bir dönem yaklaşıyor.",
    tavsiye: "Hafifliğe izin ver. Ağırlığı bırak, uçmaya hazırlan.",
    uyari: "Aşırı iyimserlik gerçekçiliği gölgelemesin.",
  },
  {
    id: "sezgi",
    no: 14,
    isim: "Sezgi",
    gelenekselAd: "Caput Draconis",
    pattern: ["tek", "cift", "cift", "cift"],
    sembol: "●\n●●\n●●\n●●",
    anaTemalar: ["Derin bağ", "Strateji", "Uzun vadeli", "Kadim bilgi"],
    genelAnlam: "Derin bağlantılar ve kadim bilginin devreye girdiği bir dönem. Sezgiler güçlü.",
    askAnlam: "İlişkide derin ve anlamlı bir bağ. Ruhsal bir uyum söz konusu.",
    isAnlam: "Uzun vadeli stratejiler ve derin analizler başarıyı getiriyor.",
    paraAnlam: "Uzun vadeli yatırımlar ve stratejik finansal kararlar için uygun dönem.",
    gelecekAnlam: "Derin sezgiler ve stratejik düşünce seni ileriye taşıyacak.",
    tavsiye: "Sezgilerine ve derin bilgine güven. Yüzey altında çok şey var.",
    uyari: "Sırları ve bilgiyi doğru kişilerle paylaş. Herkese açma.",
  },
  {
    id: "donusum",
    no: 15,
    isim: "Dönüşüm",
    gelenekselAd: "Cauda Draconis",
    pattern: ["cift", "tek", "tek", "tek"],
    sembol: "●●\n●\n●\n●",
    anaTemalar: ["Kader", "Değişim", "Dönüşüm", "Yenilenme"],
    genelAnlam: "Köklü bir dönüşüm zamanı. Kader devreye giriyor, değişime direnmek zorlaşıyor.",
    askAnlam: "İlişkide köklü bir değişim veya dönüşüm. Eski kalıplar kırılıyor.",
    isAnlam: "Kariyer veya iş hayatında köklü bir değişim kapıda. Buna hazır ol.",
    paraAnlam: "Maddi anlamda köklü bir yeniden yapılanma dönemi.",
    gelecekAnlam: "Dönüşüm kaçınılmaz. Akan nehire karşı yüzme.",
    tavsiye: "Değişime teslim ol. En güçlü dönüşümler kabullenmekle başlar.",
    uyari: "Kontrolü bırakmak zor ama gerekli. Güven.",
  },
  {
    id: "zafer",
    no: 16,
    isim: "Zafer",
    gelenekselAd: "Fortuna Minor",
    pattern: ["cift", "cift", "cift", "tek"],
    sembol: "●●\n●●\n●●\n●",
    anaTemalar: ["Tatmin", "Hedef", "Küçük kazanç", "Sonuç"],
    genelAnlam: "Küçük ama değerli zaferler ve tatmin dönemi. Hedeflere adım adım ulaşılıyor.",
    askAnlam: "İlişkide küçük ama anlamlı adımlar atılıyor. Sabır meyve veriyor.",
    isAnlam: "İş hayatında somut ve görünür başarılar. Çabalar karşılığını buluyor.",
    paraAnlam: "Küçük ama düzenli kazanımlar maddi dengeyi güçlendiriyor.",
    gelecekAnlam: "Hedeflere ulaşma dönemi. Sabır ve kararlılık ödüllendiriliyor.",
    tavsiye: "Küçük zaferleri kutla. Büyük başarılar küçük adımların toplamıdır.",
    uyari: "Mükemmeli beklerken iyiyi kaçırma.",
  },
];

export const REMIL_TOKEN_BEDELI = 30;

export const REMIL_ACILIM_POZISYONLARI = [
  { id: "baslangic", isim: "Başlangıç", aciklama: "Durumun kökü ve başlangıç noktası" },
  { id: "mevcutDurum", isim: "Mevcut Durum", aciklama: "Şu an yaşanan ve hissedilen" },
  { id: "etkileyenFaktor", isim: "Etkileyen Faktör", aciklama: "Süreci şekillendiren gizli güç" },
  { id: "karsıTaraf", isim: "Karşı Taraf / Çevre", aciklama: "Dışarıdan gelen etkiler" },
  { id: "firsat", isim: "Fırsat", aciklama: "Kapıyı aralayan olasılık" },
  { id: "engel", isim: "Engel", aciklama: "Aşılması gereken zorluk" },
  { id: "sonuc", isim: "Sonuç", aciklama: "Gidişatın işaret ettiği nokta" },
];
